import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";

const WalletsLayout = () => {
  const navList = useNav();
  let { WalletsBottomHeader, WalletsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={WalletsBottomHeader} topTabs={WalletsTopHeader} />
      <Outlet />
    </div>
  );
};

export default WalletsLayout;
